import { CloudCommand } from "../types.js";

export const getInvitationsCount: CloudCommand = {
    action: "USER_INFOS/GET_INVITATIONS_COUNT",
    commandName: "linkedin.user.getInvitationsCount",
    buildPayload: () => ({}),
};
